import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'lokos-filter-chip',
    standalone: false,
    templateUrl: './filter-chip.component.html',
    styleUrl: './filter-chip.component.scss'
})
export class FilterChipComponent {
    @Input() form!: FormGroup;
    @Input() useForm = true;
    @Input() labels: Record<string, string> = {};
    @Input() displayMonthYear!: string;
    @Input() showClearAll = false;
    @Output() remove = new EventEmitter<string>();
    @Output() clear = new EventEmitter<void>();

    get activeFilters (): string[] {
        return Object.keys(this.form?.value || {}).filter(
            key => this.form.value[key] && this.labels[key]
        );
    }

    get noFormFilters (): string[] {
        return Object.keys(this.labels || {}).filter(
            key => this.labels[key]
        );
    }

    onRemove (key: string) {
        this.remove.emit(key);
    }

    onClear () {
        this.clear.emit();
    }
}
